module.exports = __webpack_public_path__ + "static/media/dangerous.90faa676.webp";